import { useEffect, useState } from 'react';

import { chicagoSeconds } from '@/utils/rotations';

/** Same cadence as the /rotations kiosk's local clock. */
export const CLOCK_TICK_MS = 5_000;

/**
 * Seconds since Chicago midnight, re-read every 5 s while `active` (the
 * screen is showing today). Countdowns and row colours derive from it, so
 * nothing re-fetches as rotations change.
 */
export function useChicagoSeconds(active: boolean): number {
  const [now, setNow] = useState(() => chicagoSeconds());
  useEffect(() => {
    if (!active) return undefined;
    setNow(chicagoSeconds());
    const id = setInterval(() => setNow(chicagoSeconds()), CLOCK_TICK_MS);
    return () => clearInterval(id);
  }, [active]);
  return now;
}
